<template>
  <div class="main">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import "~@/config/styles/variables.scss";
.main{
  min-height: calc(100vh - 196px);
  flex:auto !important;
}
.app-main {
  /* 50= navbar  50  */
  height: 100%;
  width: 100%;
  padding: $appMainPadding;
  position: relative;
}

.fixed-header+.app-main {
  padding-top: 50px;
}

.hasTagsView {
  // .app-main {
  //   /* 84 = navbar + tags-view = 50 + 34 */
  //   height: calc(100vh - #{$tabsHeight} - #{$headerHeight});
  // }

  .fixed-header+.app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
